(function () {
  var KEY = 'vc_cookie_consent';
  if (localStorage.getItem(KEY)) return; // already decided

  var banner = document.getElementById('vc-cookie-banner');
  if (!banner) return;

  // Show with slight delay so page paint completes first
  setTimeout(function () {
    banner.classList.add('vc-cb-visible');
  }, 600);

  function dismiss(value) {
    localStorage.setItem(KEY, value);
    banner.classList.remove('vc-cb-visible');
    setTimeout(function () { banner.style.display = 'none'; }, 400);
  }

  document.getElementById('vc-cb-accept').addEventListener('click', function () {
    dismiss('accepted');
  });
  document.getElementById('vc-cb-decline').addEventListener('click', function () {
    dismiss('declined');
  });
})();
